import React from "react";
import { TimeDepositDetailResp } from "domain/payload/response/bankamar/TimeDepositResp";

interface Props {
  item: TimeDepositDetailResp;
  onClose: () => void;
}

const TimeDepositDetailModal: React.FC<Props> = ({ item, onClose }) => {
  if (!item?.data) return null;
  
  const data = item.data;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Time Deposit Detail</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p>
              <b>ID:</b> {data.id}
            </p>
            <p>
              <b>Partner Customer ID:</b> {data.partnerCustomerId}
            </p>
            <p>
              <b>Partner Customer Email:</b> {data.partnerCustomerEmail}
            </p>
            <p>
              <b>Account Number:</b> {data.accountNumber}
            </p>
            <p>
              <b>Status Code:</b> {data.statusCode}
            </p>
            <p>
              <b>Event Type:</b> {data.eventType}
            </p>
            <p>
              <b>Timestamp:</b> {data.timestamp}
            </p>

            <hr />
            <h6>Transaction Data</h6>
            <p>
              <b>Tenor:</b> {data.transactionData?.tenor} bulan
            </p>
            <p>
              <b>Amount:</b> Rp {data.transactionData?.amount?.toLocaleString()}
            </p>
            <p>
              <b>Deposito Account Number:</b>{" "}
              {data.transactionData?.depositoAccountNumber}
            </p>
            <p>
              <b>Deposito Name:</b> {data.transactionData?.depositoName}
            </p>

            <hr />
            <h6>Additional Info</h6>
            <p>
              <b>Info 1:</b> {data.transactionAdditionalInfo?.info1}
            </p>
            <p>
              <b>Info 2:</b> {data.transactionAdditionalInfo?.info2}
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeDepositDetailModal;
